import { render, staticRenderFns } from "./TrainBlock.vue?vue&type=template&id=b0f1fdde&scoped=true"
import script from "./TrainBlock.vue?vue&type=script&lang=js"
export * from "./TrainBlock.vue?vue&type=script&lang=js"
import style0 from "./TrainBlock.vue?vue&type=style&index=0&id=b0f1fdde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f1fdde",
  null
  
)

export default component.exports